import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
import {CalendarModule} from 'primeng/primeng';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {EmailDashboardModule} from "../email-dashboard/email-dashboard.module";
import { DashboardDocumentComponent } from './dashboard-document/dashboard-document.component';

@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        DropdownModule,
        FormsModule,
        CalendarModule,
        NgbDropdownModule,
        TranslateModule,
        EmailDashboardModule
    ],
  declarations: [
    DashboardListComponent,
    DashboardForItComponent,
    DashboardDocumentComponent
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard.module.ts